<template>
  <div id="user-edit-tab-info">

  	<vs-popup  classContent="popup-example" title="Send Pdf" :active.sync="sendPDFPopupActive">
        <form>
          	<div id="sendPdfLoadingDiv" class="vs-con-loading__container">
	          	<div class="vx-row mb-4">
		            <div class="vx-col w-full">
		              	Police Station
		            	<v-select v-validate="'required'" name="policeStation" v-model="policeStation" :options="policeStationData" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
		              	<span class="text-danger text-sm" v-show="errors.has('policeStation')">{{ errors.first('policeStation') }}</span>
		            </div>
	          	</div>

	          	<div v-if="checkShowCustomEmail()" class="vx-row mb-4">
		            <div class="vx-col w-full">
		              	<vs-input type="email" class="w-full" label="Custom Email" v-model="policeStationEmail" v-validate="'required|email'" name="policeStationEmail"/>
		              	<span class="text-danger text-sm"  v-show="errors.has('policeStationEmail')">{{ errors.first('policeStationEmail') }}</span>
		            </div>
	          	</div>

	          	<div class="vx-row">
		            <div align="right" class="vx-col w-full">
		              	<vs-button v-on:click.prevent="validateSendPdfForm()" class="mb-2">Send Pdf</vs-button>
		            </div>
	          	</div>
	        </div>
        </form>
    </vs-popup>

    <div v-if="userPackages">
        <vs-table :data="userPackages">
            <template align="center" slot="thead">
                <vs-th>Name</vs-th>
                <vs-th>Cost</vs-th>
                <vs-th>Total Classes</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :state="null" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{tr['packages']['name']}}
                    </vs-td>
                    <vs-td>
                        {{tr['packages']['cost']}} $
                    </vs-td>
                    <vs-td>
                        {{tr['packages']['module_id'].length}}
                    </vs-td>
                    <vs-td>
                        <vs-button  v-on:click.prevent="sendPDF(tr['packages']['id'])" class="mr-1"  color="danger" type="gradient">Send PDF</vs-button>
                        <vs-button :disabled="disableDownloadPDFBtn" ref="loadableButton" id="downloadPDFBtn" class="mr-1 vs-con-loading__container" v-on:click.prevent="downloadPDF(tr['packages']['id'])"  color="danger" type="gradient">Download PDF</vs-button>
					    <vs-button :disabled="disableDownloadLogBtn" ref="loadableButton" id="downloadLogBtn" class="btn-drop mr-1 vs-con-loading__container"  color="danger" type="gradient"  v-on:click.prevent="downloadLog(tr['packages']['id'])">Download Log</vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import moduleClassManagement from '@/store/class-management/moduleClassManagement.js'

export default {
	components: {
		vSelect
	},
	props: {
		data: {
		  	type: Object,
		  	required: true,
		},
	},
	data() {
		return {
		  	data_local: JSON.parse(JSON.stringify(this.data)),
		  	userPackages : [],
		  	disableDownloadPDFBtn : false,
		  	disableDownloadLogBtn : false,
		  	sendPDFPopupActive : false,
		  	policeStationData : [],
		  	policeStation : null,
		  	policeStationEmail : null,
		  	packageId : null,
		}
	},
	computed: {

	},
	methods: {
		checkShowCustomEmail() {
			if(this.policeStation && this.policeStation.id && this.policeStation.id == 'custom') return true
			else return false
		},
		validateSendPdfForm() {
			this.$validator.validateAll().then(result => {
				if (result) this.sendPdfToStation()
			})
	    },
	    async sendPdfToStation() {
	    	this.$vs.loading({
	          	container: '#sendPdfLoadingDiv',
	          	scale: 0.6
	      	});

	    	let data = {
				package_id : this.packageId,
				student_id : this.data_local.id,
			}

			if(this.policeStation.id != 'custom') data.station_id = this.policeStation.id
			if(this.policeStationEmail != null) data.custom_email = this.policeStationEmail
			
			await this.$store.dispatch("userManagement/sendPdf", data)


			await this.$store.dispatch("classManagement/sendPDF", data)
			    .then(res => { 
			      	this.$vs.notify({
		                title: "Success.",
		                text: "Pdf successfully send.",
		                iconPack: "feather",
		                icon: "icon-alert-circle",
		                color: "success"
		            });

		            this.$vs.loading.close('#sendPdfLoadingDiv > .con-vs-loading')
			    })
			    .catch(err => { 
			    	this.$vs.loading.close('#sendPdfLoadingDiv > .con-vs-loading')
			    })
	 
	    },
		getStudentPackages() {
		  this.$store.dispatch("classManagement/getStudentPackages", this.data_local.id)
		    .then(res => { 
		    	this.userPackages = res.data
		    })
		    .catch(err => { 

		    })
		},
		async getPoliceStationData() {
			let policeStationData = []
		  	await this.$store.dispatch("classManagement/getPoliceStationData", this.data_local.id)
			    .then(res => { 
			      	res.data.forEach(function(entry, key) {
				        policeStationData.push({
							id : entry.id,
							label : entry.name,
				        })
			      	});
			    })
			    .catch(err => { 

			    })

			policeStationData.push({
				id : 'custom',
				label : 'Enter an email',
	        })

	      	this.policeStationData = policeStationData
		},
		sendPDF(packageId) {
			this.sendPDFPopupActive = true
			this.packageId = packageId
		},
		downloadPDF(packageId) {
			this.$vs.loading({
		        background: 'danger',
		        color: '#fff',
		        container: "#downloadPDFBtn",
		        scale: 0.45
		    })

		    this.disableDownloadPDFBtn = true

			let data = {
				package_id : packageId,
				student_id : this.data_local.id,
			}

			this.$store.dispatch("classManagement/downloadPDF", data)
			    .then(res => { 
			    	this.disableDownloadPDFBtn = false
			    	this.$vs.loading.close("#downloadPDFBtn > .con-vs-loading")

			    	if(res.data.pdf){
			    		var link = document.createElement('a');
						link.target = "_blank";
						link.href = res.data.pdf;
						link.download = this.data_local.name+" "+this.data_local.lastname+" -Logbog.pdf";
						link.dispatchEvent(new MouseEvent('click'));
			    	}
			    })
			    .catch(err => { 
			    	this.disableDownloadPDFBtn = false
			    	this.$vs.loading.close("#downloadPDFBtn > .con-vs-loading")
			    })
		},
		async downloadLog(packageId) {
			this.$vs.loading({
		        background: 'danger',
		        color: '#fff',
		        container: "#downloadLogBtn",
		        scale: 0.45
		    })

		    this.disableDownloadLogBtn = true

			let data = {
				package_id : packageId,
				student_id : this.data_local.id,
			}

			await this.$store.dispatch("userManagement/fetchStudentLogbokClassesForPackage", data)
		        .then(res => { 
		          	this.disableDownloadLogBtn = false
					this.$vs.loading.close("#downloadLogBtn > .con-vs-loading")

		          	let classLogArrayData = []
		          	classLogArrayData.push([
		          		"Lektion nr",
		          		"Modul",
		          		"Faktisk anvendt tid",
		          		"Student booked date & time",
		          		"Student booked actual date & time",
		          		"Teacher",
		          		"Teacher signed date & time",
		          		"Teacher signed actual date & time",
		          	])

                    res.data.forEach(function(entry, key) {
                        let currentData = [
                        	entry.lektion_nr_string_final+"   "+entry.hours_1,
                        	entry.name,
                        	entry.hours_2,
                        	entry.booked_date ? entry.booked_date+" "+entry.booked_time : "",
                        	entry.student_signed_actual_time ? entry.student_signed_actual_time : "",
                        	entry.teacher_data.name ? entry.teacher_data.name+" "+entry.teacher_data.last_name : "",
                        	entry.signed_date_time ? entry.signed_date_time : "",
                        	entry.teacher_signed_actual_time ? entry.teacher_signed_actual_time : "",
                        ];

                        classLogArrayData.push(currentData)
                    });

		          	this.exportToCsv(this.data_local.name+" "+this.data_local.last_name+".csv", classLogArrayData)
		        })
		        .catch(err => {
		          	this.disableDownloadLogBtn = false
					this.$vs.loading.close("#downloadLogBtn > .con-vs-loading")
		        })

		},
		exportToCsv(filename, rows) {
	        var processRow = function (row) {
	            var finalVal = '';
	            for (var j = 0; j < row.length; j++) {
	                var innerValue = row[j] === null ? '' : row[j].toString();
	                if (row[j] instanceof Date) {
	                    innerValue = row[j].toLocaleString();
	                };
	                var result = innerValue;
	                var result = innerValue.replace(/"/g, '""');
	                if (result.search(/("|,|\n)/g) >= 0)
	                    result = '"' + result + '"';
	                if (j > 0)
	                    finalVal += ',';
	                finalVal += result;
	            }
	            return finalVal + '\n';
	        };

	        var csvFile = '';
	        for (var i = 0; i < rows.length; i++) {
	            csvFile += processRow(rows[i]);
	        }

	        var blob = new Blob([new Uint8Array([0xEF,0xBB,0xBF]),csvFile],{type:'application/csv;charset=UTF-8'});

	        if (navigator.msSaveBlob) {
	            navigator.msSaveBlob(blob, filename);
	        } else {
	            var link = document.createElement("a");
	            if (link.download !== undefined) { 
	                var url = URL.createObjectURL(blob);
	                link.setAttribute("href", url);
	                link.setAttribute("download", filename);
	                link.style.visibility = 'hidden';
	                document.body.appendChild(link);
	                link.click();
	                document.body.removeChild(link);
	            }
	        }
	    }

	},
	created() {
		if(!moduleClassManagement.isRegistered) {
		  	this.$store.registerModule('classManagement', moduleClassManagement)
		 	moduleClassManagement.isRegistered = true
		}

		this.getStudentPackages()
		this.getPoliceStationData()
	}
}
</script>
